var _defs, _circle, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKpmg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .kpmg-text { font-family: Arial, sans-serif; font-size: 28px; font-weight: bold; fill: white; }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#0052CC"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 115,
    className: "kpmg-text",
    textAnchor: "middle"
  }, "KPMG")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpmg);
export default __webpack_public_path__ + "static/media/KPMG.a90481856b361885bafb9011fb440e3a.svg";
export { ForwardRef as ReactComponent };